import { api } from '@cwd/lib/main';

export async function syncModeraterna(func: 'organizations' | 'users'): Promise<void> {
    return api.get(`/customers/moderaterna?function=${func}`);
}

export async function moveFromSmsQueue(): Promise<void> {
    return api.get('/backoffice/movefromsmsrecipientqueue');
}

export async function triggerExport(): Promise<void> {
    return api.post('/backoffice/testexport', null);
}
